// extracted by mini-css-extract-plugin
export default {"loading":"auditLogsData_loading__N16ih","row_details":"auditLogsData_row_details__20gMA","target":"auditLogsData_target__WN357","capitalize":"auditLogsData_capitalize__iMcWF"};